import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { EmailAddress } from '../models/email-address';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class EmailAddressesService extends CrudService implements AdvancedService<EmailAddress> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<EmailAddress>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<EmailAddress>(EmailAddress, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(emailAddressId: number, emailAddress: EmailAddress): Observable<EmailAddress> {
        // Appel de la Web Api
        return this.http
            .put<EmailAddress>(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses/${emailAddressId}`, emailAddress, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }

    delete(emailAddressId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<EmailAddress>(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses/${emailAddressId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(emailAddress: EmailAddress): Observable<EmailAddress> {
        emailAddress.organizationId = this.organizationId;
        // Appel de la Web Api
        return this.http.post<EmailAddress>(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses`, emailAddress, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(emailAddressId: number): Observable<EmailAddress> {
        // Appel de la Web Api
        return this.http.get<EmailAddress>(this.baseUrl + `/api/organizations/${this.organizationId}/emailAddresses/${emailAddressId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
